import React, { useState } from 'react';
import { Checkbox, Form, Input } from 'antd';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';

import useLogin from './useLogin';
import AuthLayout from './AuthLayout';
import AuthForm from './AuthForm';
import InputPassword from '@components/controls/InputPassword';
import { Path } from '../../routes';
import MediaIcon from '@assets/img/auth-media.svg';
import MailIcon from '@assets/img/input-mail.svg';
import emailValidation from '../../utils/emailValidation';

function LoginPage() {
  const { onSubmit } = useLogin();
  const { t } = useTranslation();
  const [state, setState] = useState({});

  const onBlur = (e) => {
    const value = e.target.value;
    const isEmailValid = emailValidation(value);

    setState({
      isValid: isEmailValid,
      value,
    });
  };

  const showError = !isEmpty(state.value) && state.isValid === false;

  return (
    <AuthLayout
      className="login-page"
      title={<>{t('login-page-header')}</>}
      icon={<MediaIcon width={215} height={160} />}
    >
      <AuthForm
        name="login"
        submitLabel={t('sign-in')}
        onSubmit={onSubmit}
        // onChangeFields={onChange}
      >
        <Form.Item
          className="auth-form__item"
          name="email"
          validateStatus={showError && 'error'}
          help={showError && t('enter-correct-email')}
          rules={[{ required: true, message: t('fill-your-email') }]}
        >
          <Input
            type="email"
            prefix={<MailIcon width={18} height={18} />}
            placeholder={t('email-placeholder')}
            onBlur={onBlur}
          />
        </Form.Item>
        <Form.Item
          className="auth-form__item auth-form__item--password"
          name="password"
        >
          <InputPassword placeholder={t('password-placeholder')} />
        </Form.Item>
        <Form.Item className="auth-form__item auth-form__forgot-password">
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>{t('remember-me')}</Checkbox>
          </Form.Item>

          <NavLink to={Path.FORGOT_PASSWORD}>{t('forgot-password')}</NavLink>
        </Form.Item>
      </AuthForm>
    </AuthLayout>
  );
}

export default LoginPage;
